import React from "react"
import clsx from "clsx"
import { useGlobalStore } from "@stores/globalStore"

const ResponseMessage = React.forwardRef(({ message, type }, ref) => {
  const {gaEmail} = useGlobalStore()

  return (
    <p
      className={clsx(
        { "error-msg": type === "error" },
        { "success-msg": type === "success" },
        { "info-msg": type === "info" }
      )}
      ref={ref}
    ><span className="ga-email" id="ga-email" style={{display:'none'}}>{gaEmail}</span>
      {message}
    </p>
  )
})

export default ResponseMessage
